module.exports = __webpack_public_path__ + "static/img/iphone_ldtpage1.b8d9d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldtpage1.png
// module id = yNEV
// module chunks = 0